import React, { FC, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Icon, Panel, PanelType } from "@fluentui/react";
import { LineHandling } from "../../models/LineHandling";
import { Link } from "react-router-dom";
import { mergeStyleSets, Callout, DelayedRender } from "@fluentui/react";
import { useBoolean } from "@uifabric/react-hooks";
import { State } from "../../store";
import { SofView } from "../../models/SofView";
import {
  convertLineHandlingStatusToName,
  toLineHandlingNo,
} from "../../services/Helper";
import { toNominationNo } from "../../services/Helper";
import EtaButton from "./EtaButton2";
import LastActivityButton from "./LastActivityButton";
import RoundProgressIndicator from "./RoundProgressIndicator";
import SofIcon from "../common/Icons";
import * as SofViewStore from "../../store/SofViewStore";
import * as GeneralStore from "../../store/GeneralStore";
import FileUpload from "../common/FIleUpload";
import ProgressIndicator from "./ProgressIndicator";

type Props = GeneralStore.GeneralState &
  typeof SofViewStore.actionCreators & {
    lineHandling: LineHandling;
    onEtaUpdated(lineHandling: LineHandling): void;
  };

const classes = mergeStyleSets({
  viewButton: {
    width: "39px",
    height: "39px",
    display: "block",
    padding: "6px 9px",
    marginRight: "10px",
    cursor: "pointer",
    textAlign: "center",
    selectors: {
      ":hover": {
        backgroundColor: "#EEEEEE",
        textDecoration: "none",
      },
    },
  },
  viewButtonUpload: {
    width: "39px",
    height: "39px",
    borderRadius: "5px",
    border: "1px solid #E2E6E8",
    backgroundColor: "#FAFAFA",
    display: "block",
    padding: "0",
    marginRight: "10px",
    cursor: "pointer",
    selectors: {
      ":hover": {
        backgroundColor: "#EEEEEE",
        textDecoration: "none",
      },
    },
  },
  viewIcon: {
    color: "#4C4C4C",
    margin: "auto",
    display: "block",
  },
  viewIconUpload: {
    color: "#4C4C4C",
    margin: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
    textAlign: "center",
  },
  arrowContainer: {
    width: 52,
  },
  collapsiblePanel: {
    overflow: "hidden",
    transition: "height 0.3s ease-out",
    height: 0,
  },
  ovalRejected: {
    width: "70px",
    height: "25px",
    background: "rgba(211, 47, 47, 0.2)",
    borderRadius: "50px",
    fontSize: "small",
    padding: "2px 5px",
    color: "#D32F2F",
    marginRight: "10px",
    marginTop: "7px",
    textAlign: "center",
  },
  callout: {
    width: 320,
    padding: "20px 24px",
  },
  mainPanel: {
    opacity: ".50",
  },
  listPanel: {
    width: 320,
    padding: "20px 24px",
  },
  previewPanel: {
    width: 320,
    padding: "20px 24px",
  },
});

const LineHandlingListItem2: FC<Props> = (props: Props) => {
  //  const location = useLocation();
  const { lineHandling } = props;
  const [isExpand, setIsExpand] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const [callOutId, setCallOutId] = useState("");
  const panel = useRef<HTMLDivElement>(null);
  //  const history = useHistory();

  const collapseSection = (element: HTMLDivElement) => {
    var sectionHeight = element.scrollHeight;

    var elementTransition = element.style.transition;
    element.style.transition = "";

    requestAnimationFrame(() => {
      element.style.height = sectionHeight + "px";
      element.style.transition = elementTransition;

      requestAnimationFrame(() => {
        element.style.height = 0 + "px";
      });
    });

    setIsExpanded(true);
  };

  const expandSection = (element: HTMLDivElement) => {
    var sectionHeight = element.scrollHeight;

    var event = (e: TransitionEvent) => {
      element.removeEventListener("transitionend", event);
      //element.style.height = "0";
    };

    element.style.height = sectionHeight + "px";
    element.addEventListener("transitionend", event);

    setIsExpanded(false);
  };

  //const [
  //  isOpen,
  //  { setTrue: openAttachmentPanel, setFalse: dismissAttachmentPanel },
  //] = useBoolean(false);

  useEffect(() => {
    if (panel && panel.current) {
      if (isExpanded !== isExpand) return;

      if (isExpanded) {
        expandSection(panel.current);
        setIsExpanded(false);
      } else {
        collapseSection(panel.current);
      }
    }
  }, [isExpand]);

  return (
    <>
      <div
        key={`line-handling-${lineHandling.lineHandlingNo}`}
        className="ms-Grid"
        dir="ltr"
        style={{ backgroundColor: "white", padding: "0px" }}
      >
        <div className="ms-Grid-row" style={{ padding: 20 }}>
          <div className="ms-Grid-col ms-md5">
            <div
              style={{ display: "flex", alignItems: "center", columnGap: 16 }}
            >
              <div
                style={{
                  display: "flex",
                  padding: 12,
                  justifyContent: "center",
                  borderRadius: 99,
                  background: "#F3F4F6",
                }}
              >
                {
                  <>
                    {lineHandling.vesselType === "Vessel" ? (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_63_448"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="24"
                          height="24"
                        >
                          <rect width="24" height="24" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_63_448)">
                          <path
                            d="M4.33463 18.4808L2.6654 12.4924C2.62182 12.3116 2.63945 12.1071 2.7183 11.8789C2.79713 11.6507 2.9577 11.4962 3.2 11.4154L4.5 10.9654V6.50006C4.5 5.99494 4.675 5.56738 5.025 5.21738C5.375 4.86738 5.80257 4.69238 6.3077 4.69238H9.5V1.69238H14.5V4.69238H17.6922C18.1974 4.69238 18.625 4.86738 18.975 5.21738C19.325 5.56738 19.5 5.99494 19.5 6.50006V10.9654L20.8 11.4154C21.0858 11.5231 21.2653 11.6869 21.3384 11.9068C21.4115 12.1266 21.423 12.3218 21.373 12.4924L19.6653 18.4808C18.9474 18.3846 18.2964 18.1455 17.7125 17.7635C17.1285 17.3814 16.5577 16.8769 16 16.25C15.4615 16.8705 14.865 17.4006 14.2105 17.8404C13.5561 18.2801 12.8192 18.5 12 18.5C11.1807 18.5 10.4439 18.2801 9.7894 17.8404C9.13492 17.4006 8.53844 16.8705 7.99998 16.25C7.44869 16.8769 6.87947 17.3814 6.2923 17.7635C5.70512 18.1455 5.05256 18.3846 4.33463 18.4808ZM2.25 22.5V21H3.99998C4.69998 21 5.39164 20.8917 6.07498 20.675C6.75831 20.4584 7.39998 20.1334 7.99998 19.7C8.59998 20.1334 9.24164 20.45 9.92497 20.65C10.6083 20.85 11.3 20.95 12 20.95C12.7 20.95 13.3916 20.85 14.075 20.65C14.7583 20.45 15.4 20.1334 16 19.7C16.6 20.1334 17.2416 20.4584 17.925 20.675C18.6083 20.8917 19.3 21 20 21H21.75V22.5H20C19.3 22.5 18.6166 22.4166 17.95 22.25C17.2833 22.0833 16.6333 21.8333 16 21.5C15.3666 21.8334 14.7125 22.0834 14.0375 22.25C13.3625 22.4167 12.6833 22.5 12 22.5C11.3166 22.5 10.6375 22.4167 9.96248 22.25C9.28748 22.0834 8.63331 21.8334 7.99998 21.5C7.36664 21.8334 6.71664 22.0834 6.04998 22.25C5.38331 22.4167 4.69998 22.5 3.99998 22.5L2.25 22.5ZM5.99997 10.4693L12 8.51928L18 10.4693V6.50003C18 6.41028 17.9711 6.33657 17.9134 6.27888C17.8557 6.22118 17.782 6.19233 17.6922 6.19233H6.3077C6.21795 6.19233 6.14423 6.22118 6.08653 6.27888C6.02883 6.33657 5.99997 6.41028 5.99997 6.50003V10.4693ZM12 17C12.7833 17 13.4426 16.7266 13.9778 16.1798C14.5131 15.6331 15.1872 14.8898 16 13.95C16.7936 14.85 17.3336 15.4635 17.6202 15.7904C17.9067 16.1173 18.25 16.3975 18.65 16.6308L19.75 12.65L12 10.1L4.2192 12.65L5.34998 16.6C5.74998 16.3667 6.09324 16.1 6.37978 15.8C6.66633 15.5 7.20639 14.8834 7.99998 13.95C8.83331 14.9 9.51248 15.6459 10.0375 16.1875C10.5625 16.7292 11.2166 17 12 17Z"
                            fill="#1C1B1F"
                          />
                        </g>
                      </svg>
                    ) : (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_63_482"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="24"
                          height="24"
                        >
                          <rect width="24" height="24" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_63_482)">
                          <path
                            d="M2.25 18.5V16.9904C2.83847 16.9391 3.28431 16.7612 3.58753 16.4567C3.89073 16.1523 4.46988 16 5.325 16C6.22757 16 6.85673 16.1667 7.2125 16.5C7.56827 16.8333 8.04743 17 8.65 17C9.30257 17 9.79904 16.8333 10.1394 16.5C10.4798 16.1667 11.1 16 12 16C12.9 16 13.5202 16.1667 13.8606 16.5C14.201 16.8333 14.6974 17 15.35 17C15.9526 17 16.4317 16.8333 16.7875 16.5C17.1433 16.1667 17.7724 16 18.675 16C19.5494 16 20.1285 16.149 20.4125 16.4471C20.6965 16.7452 21.1423 16.9263 21.75 16.9904V18.5C20.9667 18.5 20.3984 18.3333 20.0452 18C19.692 17.6667 19.2269 17.5 18.65 17.5C18.0243 17.5 17.5352 17.6667 17.1827 18C16.8301 18.3333 16.2109 18.5 15.325 18.5C14.4122 18.5 13.7962 18.3333 13.4769 18C13.1577 17.6667 12.6654 17.5 12 17.5C11.3346 17.5 10.8423 17.6667 10.5231 18C10.2038 18.3333 9.58782 18.5 8.675 18.5C7.7891 18.5 7.16988 18.3333 6.81733 18C6.46476 17.6667 5.97565 17.5 5.35 17.5C4.76667 17.5 4.3016 17.6667 3.9548 18C3.60802 18.3333 3.03973 18.5 2.25 18.5ZM6.13465 14.5C5.7667 14.5 5.41382 14.433 5.076 14.299C4.73818 14.165 4.44043 13.966 4.18273 13.7019L2.99045 12.5L4.03465 11.4558L5.23655 12.6327C5.35578 12.7519 5.49233 12.843 5.64618 12.9058C5.80003 12.9686 5.96285 13 6.13465 13H7.50003V9.25961L6.17503 10.2346L5.28853 9.03849L12 4.10583L18.7019 9.02886L17.8154 10.25L16.5 9.28461V13H17.8654C18.0372 13 18.2 12.9686 18.3538 12.9058C18.5077 12.843 18.6442 12.7519 18.7635 12.6327L19.9654 11.4558L21.0096 12.5L19.8173 13.6923C19.5532 13.9564 19.2538 14.157 18.9192 14.2942C18.5846 14.4314 18.2333 14.5 17.8654 14.5H6.13465ZM9 13H11.25V11H12.75V13H15V8.17501L12 5.96539L9 8.16539V13Z"
                            fill="#1C1B1F"
                          />
                        </g>
                      </svg>
                    )}
                  </>
                }
              </div>
              <div>
                <div
                  style={{ fontSize: 16, fontWeight: 700, lineHeight: "24px" }}
                >
                  {lineHandling.vesselName}
                </div>
                <div
                  style={{ fontSize: 14, fontWeight: 400, lineHeight: "24px" }}
                >
                  Line Handling #: {toLineHandlingNo(lineHandling)}
                </div>
              </div>
            </div>
          </div>
          <div className="ms-Grid-col ms-md3">
            <div style={{ fontSize: 14, fontWeight: 500, lineHeight: "24px" }}>
              <EtaButton
                lineHandling={lineHandling}
                isEditETAAllowed={props.isMarineEditETAAllowed}
                onSuccess={(value: string) => {
                  lineHandling.eta = value;
                  props.onEtaUpdated(lineHandling);
                }}
              />
            </div>
            {/* <div style={{ fontSize: 14, fontWeight: 400, lineHeight: "24px" }}>
              {convertLineHandlingStatusToName(lineHandling.status)} Date
            </div> */}
          </div>
          <div className="ms-Grid-col ms-md3">
            <ProgressIndicator
              label=""
              // label="Nomination"
              secondaryText={`${lineHandling.progress}%`}
              value={lineHandling.progress}
            />
          </div>
          <div
            className="ms-Grid-col ms-md1"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: 48,
            }}
          >
            {lineHandling.status >= 3 && lineHandling.status != 6 && (
              <Link
                id={`lnk-${lineHandling.lineHandlingNo}`}
                className={classes.viewButton}
                to={`/review?linehandling=${lineHandling.lineHandlingNo}`}
              >
                <Icon iconName="Starburst" className={classes.viewIcon} />
              </Link>
            )}
            <Link
              id={`lnk-${lineHandling.lineHandlingNo}`}
              className={classes.viewButton}
              to={`/marine/${lineHandling.lineHandlingNo}/sof`}
            >
              <Icon iconName="ChevronRight" className={classes.viewIcon} />
            </Link>
          </div>
        </div>
        {/*<div*/}
        {/*  onClick={() => setIsExpand((previousVal) => !previousVal)}*/}
        {/*  className="ms-Grid-row"*/}
        {/*  style={{*/}
        {/*    display: "flex",*/}
        {/*    alignItems: "center",*/}
        {/*    padding: "12px",*/}
        {/*    borderBottom: "1px solid #E2E6E8",*/}
        {/*    borderLeft: `7px solid ${nomination?.isNew ? "#4CAF50" : "#FFF"}`,*/}
        {/*    marginLeft: `0`*/}
        {/*  }}*/}
        {/*>*/}
        {/*  {history.location.pathname.indexOf("truck") > 0 && (*/}
        {/*    <>*/}
        {/*      <div className="ms-Grid-col ms-md2">*/}
        {/*        <div className={`truck-icon2`}>*/}
        {/*          {nomination.nominationType === "Load" && "L"}*/}
        {/*          {nomination.nominationType === "Discharge" && "O"}*/}
        {/*        </div>*/}
        {/*        <span className="list-item-title">{nomination.tank}</span>*/}
        {/*      </div>*/}
        {/*      <div className="ms-Grid-col ms-md1">{nomination.customerOrderNo}</div>*/}
        {/*      <div className="ms-Grid-col ms-md1" style={{ padding: 0 }}>*/}
        {/*        {nomination.loadingSpot}*/}
        {/*      </div>*/}
        {/*    </>*/}
        {/*  )}*/}
        {/*  {history.location.pathname.indexOf("rail") > 0 && (*/}
        {/*    <>*/}
        {/*      <div className="ms-Grid-col ms-md1">*/}
        {/*        <div className={`truck-icon2`}>*/}
        {/*          {nomination.nominationType === "Load" && "L"}*/}
        {/*          {nomination.nominationType === "Discharge" && "O"}*/}
        {/*        </div>*/}
        {/*        <span className="list-item-title">{nomination.tank}</span>*/}
        {/*      </div>*/}
        {/*      <div className="ms-Grid-col ms-md1" style={{ padding: 0 }}>*/}
        {/*        {nomination.railcars}*/}
        {/*      </div>*/}
        {/*      <div className="ms-Grid-col ms-md1" style={{ padding: 0 }}>*/}
        {/*        {nomination.loadingSpot}*/}
        {/*      </div>*/}
        {/*    </>*/}
        {/*  )}*/}
        {/*  <div className={`ms-Grid-col ms-md${history.location.pathname.indexOf("truck") > 0 ? '1' : '2'}`} style={{ color: "#4C4C4C" }}>*/}
        {/*    #{toNominationNo(nomination.nominationNo)}*/}
        {/*  </div>*/}
        {/*  <div className="ms-Grid-col ms-md2">*/}
        {/*    <input*/}
        {/*      type="text"*/}
        {/*      disabled={!props.isTruckUpdateAssignmentAllowed}*/}
        {/*      value={assignedTo}*/}
        {/*      onClick={(e) => e.stopPropagation()}*/}
        {/*      onChange={(e) => setAssignedTo(e.target.value)}*/}
        {/*      onBlur={() => updateAssignedTo(assignedTo)}*/}
        {/*      maxLength={30}*/}
        {/*      style={{*/}
        {/*        width: "100%",*/}
        {/*        padding: "5px 24px 5px 8px",*/}
        {/*        border: "1px solid #E2E6E8"*/}
        {/*      }}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*{!(props.modality === 2 && props.selectedTab === "Expected") &&*/}
        {/*
         */}
        {/*}*/}
        {/*<div className="ms-Grid-col ms-md2">*/}
        {/*    <EtaButton*/}
        {/*        nomination={nomination}*/}
        {/*        onSuccess={(value: string) => {*/}
        {/*            nomination.eta = value;*/}
        {/*            props.onEtaUpdated(nomination);*/}
        {/*        }}*/}
        {/*    />*/}
        {/*</div>*/}
        {/*  <div*/}
        {/*    className="ms-Grid-col ms-md1 progress-item"*/}
        {/*    style={{ paddingLeft: "40px" }}*/}
        {/*  >*/}
        {/*    <RoundProgressIndicator value={nomination.progress} />*/}
        {/*  </div>*/}
        {/*  <div*/}
        {/*    className="ms-Grid-col ms-md2"*/}
        {/*    style={{*/}
        {/*      display: "flex",*/}
        {/*      flexDirection: "row-reverse"*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    <div className={classes.viewButton}>*/}
        {/*      <Icon*/}
        {/*        iconName={isExpand ? "ChevronUp" : "ChevronDown"}*/}
        {/*        className={classes.viewIcon}*/}
        {/*      />*/}
        {/*    </div>*/}
        {/*    <Link*/}
        {/*      id={`lnk-${nomination.nominationNo}`}*/}
        {/*      className={classes.viewButton}*/}
        {/*      to={`${location.pathname}/${nomination.nominationNo}/sof`}*/}
        {/*    >*/}
        {/*      <svg*/}
        {/*          width="19"*/}
        {/*          height="21"*/}
        {/*          viewBox="0 0 19 21"*/}
        {/*          fill="none"*/}
        {/*          xmlns="http://www.w3.org/2000/svg"*/}
        {/*        >*/}
        {/*          <path*/}
        {/*            d="M6.2002 0.400391C5.56368 0.400391 4.95323 0.653247 4.50314 1.10333C4.05305 1.55342 3.8002 2.16387 3.8002 2.80039V9.04879C4.19245 8.93775 4.59418 8.86343 5.0002 8.82679V2.80039C5.0002 2.48213 5.12662 2.17691 5.35167 1.95186C5.57671 1.72682 5.88194 1.60039 6.2002 1.60039H11.0002V5.80039C11.0002 6.27778 11.1898 6.73562 11.5274 7.07318C11.865 7.41075 12.3228 7.60039 12.8002 7.60039H17.0002V17.2004C17.0002 17.5187 16.8738 17.8239 16.6487 18.0489C16.4237 18.274 16.1185 18.4004 15.8002 18.4004H11.4802C11.2618 18.8278 10.9974 19.2302 10.6918 19.6004H15.8002C16.4367 19.6004 17.0472 19.3475 17.4973 18.8974C17.9473 18.4474 18.2002 17.8369 18.2002 17.2004V6.89719C18.1998 6.41996 18.0099 5.96243 17.6722 5.62519L12.9754 0.92719C12.638 0.589969 12.1805 0.400492 11.7034 0.400391H6.2002ZM16.7518 6.40039H12.8002C12.6411 6.40039 12.4885 6.33718 12.3759 6.22465C12.2634 6.11213 12.2002 5.95952 12.2002 5.80039V1.84879L16.7518 6.40039ZM5.6002 20.8004C7.03236 20.8004 8.40588 20.2315 9.41857 19.2188C10.4313 18.2061 11.0002 16.8326 11.0002 15.4004C11.0002 13.9682 10.4313 12.5947 9.41857 11.582C8.40588 10.5693 7.03236 10.0004 5.6002 10.0004C4.16803 10.0004 2.79452 10.5693 1.78182 11.582C0.769122 12.5947 0.200195 13.9682 0.200195 15.4004C0.200195 16.8326 0.769122 18.2061 1.78182 19.2188C2.79452 20.2315 4.16803 20.8004 5.6002 20.8004ZM8.425 14.9756C8.53766 15.0883 8.60095 15.2411 8.60095 15.4004C8.60095 15.5597 8.53766 15.7125 8.425 15.8252C8.31233 15.9379 8.15953 16.0011 8.0002 16.0011C7.84086 16.0011 7.68806 15.9379 7.5754 15.8252L6.2002 14.4488V17.8004C6.2002 17.9595 6.13698 18.1121 6.02446 18.2247C5.91194 18.3372 5.75933 18.4004 5.6002 18.4004C5.44107 18.4004 5.28845 18.3372 5.17593 18.2247C5.06341 18.1121 5.0002 17.9595 5.0002 17.8004V14.4488L3.625 15.8252C3.51249 15.9379 3.35984 16.0012 3.20062 16.0013C3.0414 16.0014 2.88866 15.9383 2.776 15.8258C2.66333 15.7133 2.59997 15.5606 2.59986 15.4014C2.59975 15.2422 2.66289 15.0895 2.7754 14.9768L5.1754 12.5768C5.28706 12.4648 5.43843 12.4014 5.5966 12.4004H5.6038C5.76025 12.4011 5.91018 12.4631 6.0214 12.5732L6.025 12.5768L8.425 14.9768V14.9756Z"*/}
        {/*            fill="#7C7777"*/}
        {/*          />*/}
        {/*        </svg>*/}
        {/*    </Link>*/}
        {/*    */}
        {/* {props.isEditTimestampAllowed &&*/}
        {/*
         */}
        {/*      lineHandling.status >= 3 &&*/}
        {/*
         */}
        {/*      lineHandling.status != 6 && (*/}
        {/*
         */}
        {/*        <Link*/}
        {/*
         */}
        {/*          id={`lnk-${lineHandling.lineHandlingNo}`}*/}
        {/*
         */}
        {/*          className={classes.viewButton}*/}
        {/*
         */}
        {/*          to={`/review?linehandling=${lineHandling.lineHandlingNo}`}*/}
        {/*
         */}
        {/*          title="Review Line Handling"*/}
        {/*
         */}
        {/*          style={{ padding: "7px 5px" }}*/}
        {/*
         */}
        {/*        >*/}
        {/*
         */}
        {/*          <SofIcon*/}
        {/*
         */}
        {/*            iconname="Starburst"*/}
        {/*
         */}
        {/*            className={classes.viewIcon}*/}
        {/*
         */}
        {/*            style={{ margin: "auto" }}*/}
        {/*
         */}
        {/*          />*/}
        {/*
         */}
        {/*        </Link>*/}
        {/*
         */}
        {/*      )} */}
        {/*    <div className={classes.viewButtonUpload}>*/}
        {/*      <Icon*/}
        {/*        iconName="Attach"*/}
        {/*        className={classes.viewIconUpload}*/}
        {/*        onClick={(e) => {*/}
        {/*          e.stopPropagation();*/}
        {/*          e.preventDefault();*/}
        {/*          setSelectedNomination(nomination.nominationNo);*/}
        {/*          openAttachmentPanel();*/}
        {/*        }}*/}
        {/*      />*/}
        {/*    </div>*/}

        {/*    {nomination.isRejected && (*/}
        {/*      <span*/}
        {/*        className={classes.ovalRejected}*/}
        {/*        id={`callOut_${nomination.nominationNo}`}*/}
        {/*        onClick={(e) => {*/}
        {/*          e.stopPropagation();*/}
        {/*          setCallOutId(nomination.nominationNo);*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        Rejected*/}
        {/*      </span>*/}
        {/*    )}*/}
        {/*    {callOutId === nomination.nominationNo && (*/}
        {/*      <Callout*/}
        {/*        className={classes.callout}*/}
        {/*        target={`#callOut_${nomination.nominationNo}`}*/}
        {/*        onDismiss={() => setCallOutId("")}*/}
        {/*        role="status"*/}
        {/*        aria-live="assertive"*/}
        {/*      >*/}
        {/*        <DelayedRender>*/}
        {/*          <div>*/}
        {/*            <div*/}
        {/*              className="list-item-title"*/}
        {/*              style={{ marginLeft: "0px", marginBottom: "10px" }}*/}
        {/*            >*/}
        {/*              Reason for Rejection*/}
        {/*            </div>*/}
        {/*            <br />*/}
        {/*            {nomination.rejectReason}*/}
        {/*          </div>*/}
        {/*        </DelayedRender>*/}
        {/*      </Callout>*/}
        {/*    )}*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>
    </>
  );
};
export default connect(
  (state: State) => state.general,
  SofViewStore.actionCreators
)(LineHandlingListItem2);
